import React from "react";
import PropTypes from "prop-types";

const P = ({ title }) => {
  return <p className="text-muted mb-4">{title}</p>;
};

P.propTypes = {
  title: PropTypes.string
};

export default P;
